module.exports = __webpack_public_path__ + "static/media/Lato-Black.cb6fe25e.svg";